const SPORTS = ["All", "Pickleball", "Padel", "Cricket", "Football", "Badminton"];

export default function SportFilter({ selected, onSelect }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="sport-filter">
      {SPORTS.map((sport) => {
        const isActive = selected === sport || (sport === "All" && !selected);
        return (
          <button
            key={sport}
            onClick={() => onSelect(sport === "All" ? null : sport)}
            data-testid={`sport-filter-${sport.toLowerCase()}`}
            className={`px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider transition-all ${
              isActive
                ? "bg-[#FF5A00] text-white shadow-sm"
                : "bg-[#0A1128]/5 text-[#0A1128] hover:bg-[#0A1128]/10"
            }`}
          >
            {sport}
          </button>
        );
      })}
    </div>
  );
}
